import ProductSheetsService from 'services/ProductSheetsService';
import ProductSheetFavoritesService from 'services/ProductSheetFavoritesService';
import base from 'stores/search-base/actions';
import { cloneObject } from 'utils';
import notification from 'utils/noty';
import { translate } from 'utils/i18n';
import * as types from './mutation-types';

export default {
  ...base,
  async search({
    getters, commit, dispatch
  }) {
    dispatch('setLoadingState', true);
    commit(types.SET_RESULTS, await ProductSheetsService.search(getters.urlFilters, getters['user/token']));
    dispatch('setLoadingState', false);
  },
  async fetchMySheets({ getters, commit, dispatch }) {
    dispatch('setLoadingState', true);
    commit(types.SET_RESULTS, await ProductSheetsService.searchMySheets(getters.urlFilters, getters['user/token']));
    dispatch('setLoadingState', false);
  },
  async loadAll({ getters, commit, dispatch }) {
    dispatch('setLoadingState', true);
    commit(types.SET_RESULTS, await ProductSheetsService.loadAll(getters.resultsTotal, getters['user/token']));
    dispatch('setLoadingState', false);
  },
  async loadMore({ getters, commit, dispatch }) {
    dispatch('setLoadingState', true);
    const result = await ProductSheetsService.loadMore(getters.results.hits.length, getters['user/token']);
    commit(types.ADD_RESULTS, result.hits);
    dispatch('setLoadingState', false);
  },
  async loadMoreMySheets({ getters, commit, dispatch }) {
    dispatch('setLoadingState', true);
    const result = await ProductSheetsService.loadMoreMySheets(getters.results.hits.length, getters['user/token']);
    commit(types.ADD_RESULTS, result.hits);
    dispatch('setLoadingState', false);
  },
  async loadAllMySheets({ getters, commit, dispatch }) {
    dispatch('setLoadingState', true);
    commit(types.SET_RESULTS, await ProductSheetsService.loadAllMySheets(getters.resultsTotal, getters['user/token']));
    dispatch('setLoadingState', false);
  },
  setTab({ state, getters, dispatch }, tab) {
    if (state.availableTabs.indexOf(tab) > -1 && getters.activeTab !== tab) {
      const urlFilters = cloneObject(getters.urlFilters);
      urlFilters.tab = tab;
      dispatch('setUrlFilters', urlFilters);
      dispatch('clearBasket');
    }
  },
  addToBasket({ commit, state }, assets) {
    assets.forEach((asset) => {
      const exists = state.basket.find((a) => a.id === asset.id);
      if (!exists) {
        commit(types.ADD_TO_BASKET, asset);
      }
    });
  },
  removeFromBasket({ commit }, assets) {
    commit(types.REMOVE_FROM_BASKET, assets);
  },
  clearBasket({ commit }) {
    commit(types.CLEAR_BASKET);
  },
  async downloadBasket({ state, getters }) {
    const documentIds = state.basket
      .filter((doc) => !doc.isVirtual)
      .map((doc) => doc.id);

    const virtualMsdsProductIds = state.basket
      .filter((doc) => doc.isVirtual && doc.type === 'virtual_msds')
      .map((doc) => doc.productIds[0]);

    const hasVirtualDocuments = state.basket.filter((doc) => doc.isVirtual).length > 0;

    await getters.documentServiceClient.post(
      'download',
      {
        documentIds: documentIds ?? null,
        virtualDocuments: hasVirtualDocuments ? {
          virtual_msds: virtualMsdsProductIds.length > 0 ? {
            productIds: virtualMsdsProductIds,
            lang: state.msdsSettings?.language,
            type: state.msdsSettings?.type,
          } : null
        } : null,
      }
    );
  },
  async fetchFavorites({ getters, commit }) {
    commit(types.SET_FAVORITES, await ProductSheetFavoritesService.getForUser(getters['user/token']));
  },
  async saveFavorite({ state, getters, commit }, payload) {
    if (getters.activeTab === 'mysheets' && payload.documentTypes.length > 0) {
      const result = state.results.hits.find((hit) => hit.prd === payload.productId);
      result.assets = result.assets.filter((asset) => payload.documentTypes.indexOf(asset.type) > -1);
      commit(types.REPLACE_RESULT, result);
    }

    const favorite = await ProductSheetFavoritesService.saveFavorite(getters['user/token'], payload.productId, payload.documentTypes);
    commit(types.SAVE_FAVORITE, favorite);
  },
  async deleteFavorite({ state, getters, commit }, id) {
    if (getters.activeTab === 'mysheets') {
      const favorite = state.favorites.find((s) => s.id === id);
      commit(types.REMOVE_RESULT, favorite.productId);
    }

    await ProductSheetFavoritesService.deleteFavorite(getters['user/token'], id);
    commit(types.DELETE_FAVORITE, id);
  },
  async saveMsdsSettings({ commit }, settings) {
    commit(types.SAVE_MSDS_SETTINGS, settings);
  },
  async selectAll({
    commit, dispatch, getters,
  }) {
    if (getters.activeTab === 'mysheets') {
      await dispatch('loadAllMySheets');
    } else {
      await dispatch('loadAll');
    }

    const uniqueAssets = getters.loadedUniqueAssets;
    const documentsLimit = getters.selectAllProductsDocumentLimit;

    if (documentsLimit && uniqueAssets.length > documentsLimit) {
      notification.warning(translate('productSheets.selectAll.tooManyDocumentsWarning', { limit: documentsLimit }));
      return;
    }

    commit('SET_BASKET', uniqueAssets);
  }
};
